<template>
  <div>
    <div class="table" ref="printList">
      <p style="margin-bottom: 10px;">{{ detail.porder_sn }}-{{ detail.realname }}</p>
      <ol>
        <li class="flex05">NO</li>
        <!-- 订单号 -->
        <li class="flex15">{{ $t("message.orderNumber") }}</li>
        <!-- 番号 -->
        <li class="flex05">{{ $t("message.mash") }}</li>
        <!-- 照片 -->
        <li>{{ $t("message.pic") }}</li>
        <!-- 业务编辑 -->
        <li class="flex15">
          商品属性
        </li>
        <!-- 数量 -->
        <li>{{ $t("message.quantity") }}</li>
        <li class="flex2">
          {{ $t("message.warehouseNumber") }}
        </li>
        <!--附加服务  -->
        <li class="flex15">
          附加服务
        </li>
        <!--交易号物流号  -->
        <li class="flex15">
          交易号物流号
        </li>
        <li class="flex2">标签编号</li>
        <!-- 业务商品备注 -->
        <li>业务备注</li>
        <!-- 操作员 -->
        <li>检品备注</li>
      </ol>
      <!--  -->
      <ul v-for="(item, index) in list" :key="index">
        <li class="flex05">{{ index + 1 }}</li>
        <!-- 订单号 -->
        <li class="flex15 word-break">
          <p> {{ item.order_sn }}</p>
        </li>
        <!-- 番号 -->
        <li class="flex05">{{ item.sorting }}</li>
        <!-- 照片 -->
        <li>
          <img :src="item.pic" alt="" style="width: 60px; height: 60px" />
        </li>
        <!-- 业务编辑商品属性 -->
        <li class="flex15">
          <div class="attribute">
            <el-tooltip placement="bottom">
              <div slot="content">
                <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y != false
                  ? item.detail_y
                  : item.detail" :key="itemIndex" style="margin-bottom: 5px">
                  {{ itemDetail.key }}：{{ itemDetail.value }}
                </div>
              </div>
              <div>
                <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y != false
                  ? item.detail_y
                  : item.detail" :key="itemIndex">
                  {{ itemDetail.key }}：{{ itemDetail.value }}
                </div>
              </div>
            </el-tooltip>
          </div>
        </li>
        <!-- 数量 -->
        <li>
          <div class="template">
            <!-- 提出数 -->
            <p class="putForwardNum">
              {{ $t("message.putForwardNum") }}：{{ item.num }}
            </p>
            <!-- 待装箱 -->
            <p>
              {{ $t("message.toEncasement") }}：{{ item.wait_freight_num }}
            </p>
            <!-- 已装箱 -->
            <p>{{ $t("message.boxed") }}：{{ item.freight_num }}</p>
            <!-- 已出货 -->
            <p>{{ $t("message.shipped") }}：{{ item.delivery_num }}</p>
          </div>
        </li>
        <!-- 仓库数量 -->
        <li class="flex2">
          <div class="template">
            <div class="row" v-for="(items, indexs) in item.wms_stock" :key="indexs">
              <p>{{ items.wms_grid_name }}</p>
              <p>{{ $t("message.quantity") }}:{{ items.num }}</p>
            </div>
          </div>
        </li>
        <!-- 附加服务 -->
        <li class="flex15">
          <div class="template">
            <div v-for="(service, serviceIndex) in item.option" :key="serviceIndex">
              <p>{{ service.name }}：{{ service.num }}</p>
            </div>
          </div>
        </li>
        <!-- 交易号 物流号 -->
        <li class="flex15">
          <div class="template">
            <div class="row" v-for="(items, indexs) in item.order_purchase" :key="indexs">
              <p>
                JY:<a href="javascript:;" rel="noopener noreferrer" style="color: #fa5058">{{ items.purchase_no }}</a>
              </p>
              <p v-for="(express_no, express_noIndex) in items.order_purchase_express" :key="express_noIndex">
                WL:<a href="javascript:;" rel="noopener noreferrer" style="color: #2c96e7">{{ express_no.express_no
                }}</a>
              </p>
            </div>
          </div>
        </li>
        <!-- 标签编号 -->
        <li class="flex2">
          <div class="template">
            <div v-for="(tag, tagIndex) in item.porder_detail_tag" :key="tagIndex">
              <div class="tags">
                <div class="row">
                  <!--类别  -->
                  <div class="label">{{ $t("message.category") }}:</div>
                  <div class="value">
                    {{ tag.type }}
                  </div>
                </div>
                <div class="row">
                  <!--标签号  -->
                  <div class="label">{{ $t("message.labelNo") }}:</div>
                </div>
                <div class="row">
                  <div class="value">
                    {{ tag.no }}
                  </div>
                </div>
                <div class="row">
                  <!--商品码  -->
                  <div class="label">{{ $t("message.commodityCode") }}:</div>
                </div>
                <div class="row">
                  <div class="value">
                    {{ tag.goods_no }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
        <!-- 业务商品备注 -->
        <li>
          <span>{{ item.y_remark }} </span>
        </li>
        <!-- 操作员 -->
        <li>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {

    };
  },
  computed: {
    ...mapState(
      {
        list: (state) => state.porderDetail.list,
        detail: (state) => state.porderDetail.detail,
      }
    )
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.table {

  ol {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 99;
    text-align: center;
  }

  .flex05 {
    flex: 0.5;
  }

  .flex15 {
    flex: 1.5;
  }

  .flex2 {
    flex: 2;
  }

  li {
    font-size: 13px;
    margin-right: 10px;

    &:nth-last-child(1) {
      margin-right: 0;
    }

    /deep/.el-textarea__inner {
      min-height: 100px !important;
      padding: 5px;
    }
  }

  ul {
    li {
      overflow: hidden;
    }
  }
}

.tags {

  border-radius: 4px;

  margin-bottom: 10px;
  font-size: 12px;

  .row {
    margin-bottom: 10px;
    display: flex;
    word-break: break-all;

    &:nth-last-child(1) {
      margin: 0;
    }

    .label {
      flex: 1;
    }

    .value {
      flex: 1;

    }
  }

  .tabTitle {
    font-size: 14px;
  }
}
</style>
